import React, { useState } from 'react';
import { theme, st } from '../constants.js';

export const SectionHeader = ({ icon, title, subtitle, color }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '26px', paddingBottom: '16px', borderBottom: '2px solid #f1f5f9' }}>
    <div className="cp-section-icon" style={{ width: '48px', height: '48px', borderRadius: '14px', background: `linear-gradient(135deg,${color},${color}bb)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', flexShrink: 0 }}>{icon}</div>
    <div>
      <h3 className="cp-section-title" style={{ margin: 0, fontSize: '1.2rem', fontWeight: '800', color: theme.textMain, fontFamily: 'inherit' }}>{title}</h3>
      {subtitle && <span style={{ fontSize: '0.78rem', color: theme.textMuted, fontWeight: '500' }}>{subtitle}</span>}
    </div>
  </div>
);

export const PTReasoning = ({ children }) => (
  <div style={{ background: '#eef2ff', borderLeft: '4px solid #6366f1', borderRadius: '0 12px 12px 0', padding: '12px 16px', marginTop: '8px', marginBottom: '8px', fontSize: '0.82rem', color: '#3730a3', fontWeight: '500', lineHeight: 1.6 }}>
    <span style={{ fontWeight: '800', display: 'block', marginBottom: '4px' }}>🧠 PT Reasoning</span>
    {children}
  </div>
);

export const CanTreat = ({ can = [], cannot = [] }) => (
  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '8px', marginBottom: '4px' }}>
    {can.map(t => <span key={t} style={{ fontSize: '0.75rem', padding: '4px 10px', borderRadius: '99px', background: '#ecfdf5', color: '#065f46', border: '1px solid #6ee7b7', fontWeight: '600' }}>✅ {t}</span>)}
    {cannot.map(t => <span key={t} style={{ fontSize: '0.75rem', padding: '4px 10px', borderRadius: '99px', background: '#fef2f2', color: '#991b1b', border: '1px solid #fca5a5', fontWeight: '600' }}>❌ {t}</span>)}
  </div>
);

export const Sub = ({ title, reasoning, hint, hintType = 'hint', can, cannot, children }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const hasInfo = reasoning || hint || (can && can.length > 0) || (cannot && cannot.length > 0);
  return (
    <div style={{ marginBottom: '24px' }}>
      <p style={st.subTitle}>
        {title}
        {hasInfo && (
          <button
            type="button"
            onClick={() => setInfoOpen(o => !o)}
            aria-label={infoOpen ? 'Hide clinical reasoning' : 'Show clinical reasoning'}
            className="cp-info-btn"
            style={{
              minWidth: '44px', minHeight: '44px',
              flexShrink: 0, padding: 0,
              background: 'none', border: 'none',
              cursor: 'pointer',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            <span style={{
              width: '20px', height: '20px', borderRadius: '50%',
              background: infoOpen ? '#6366f1' : '#eef2ff',
              color: infoOpen ? '#fff' : '#6366f1',
              border: '1.5px solid #a5b4fc',
              fontSize: '11px', fontWeight: '800',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              lineHeight: 1, flexShrink: 0,
              transition: 'background 0.15s, color 0.15s',
              pointerEvents: 'none',
            }}>!</span>
          </button>
        )}
      </p>
      {infoOpen && reasoning && <PTReasoning>{reasoning}</PTReasoning>}
      {infoOpen && hint && <div style={{ ...st[hintType], marginTop: '0', marginBottom: '8px' }}>{hint}</div>}
      {infoOpen && (can?.length > 0 || cannot?.length > 0) && <CanTreat can={can || []} cannot={cannot || []} />}
      {children}
    </div>
  );
};
